import CardMemberProfile from "./CardMemberProfile";

export default CardMemberProfile;
